import {
  GET_BEACON_PENDING,
  GET_BEACON_SUCCESS,
  GET_BEACON_ERROR,
  INITIALIZE_STATE,
  RESET_STATE
} from '../ReduxActions/types';

var initialState = {
  allBeacons: [],
  pending: false,
  success: false,
  error: false
};

export default function (state = null, action) {
  let nextState = {};
  switch (action.type) {
    case INITIALIZE_STATE:
      nextState = {
        ...state,
        ...initialState
      };
      break;
    case RESET_STATE:
      nextState = null;
      break;
    case GET_BEACON_PENDING:
      nextState = {
        ...state,
        pending: true,
        success: false,
        allBeacons: []
      };
      break;
    case GET_BEACON_SUCCESS:
      nextState = {
        ...state,
        allBeacons: action.payload,
        pending: false,
        success: true
      };
      break;
    case GET_BEACON_ERROR:
      nextState = {
        ...state,
        pending: false,
        success: false,
        error: action.payload
      };
      break;
    default:
      return state;
  }
  return nextState;
}
